import type { PnpCashierContent } from './pnpCashier.types';

export const FALLBACK_CONTENT: PnpCashierContent = {
  header:           'Deposit and play',
  title:            'Add funds to start playing',
  description:      'Choose an amount and pay securely with your bank.',
  suggestedAmounts: [30, 70, 150],
  ctaLabel:         'Deposit and play',
  placeholder:      'Enter amount',
  // eslint-disable-next-line max-len
  termsText:        'By clicking "Deposit and play" button you accept our <a class="underline" href="https://casumo.com/" target="_blank">Terms and Conditions</a> and our <a class="underline" href="https://casumo.com/" target="_blank">Privacy Policy</a>.',
  errorMin:
    'That amount\'s a bit too low. Try entering a number larger than {min}',
  errorMax:
    'Whoa there! That\'s a bit too much. Try something smaller than {max}',
  errorInvalid: 'Deposit amount is required',
};
